export default "__VITE_ASSET__zkHprvG4__"